import api from '../../ApiConfig';
import { Apis } from '../../config';

import { Alerts } from '../index'

const uploadImage = async (data) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.UploadSampleGreetings, data, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};
const getSampleGreetings = async (data) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetSampleGreetings, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const deleteSampleGreetings = async (id) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.DeleteSampleGreetings + id, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const exportedObject = {
    uploadImage,
    getSampleGreetings,
    deleteSampleGreetings
};
export default exportedObject;